export default __webpack_public_path__ + "static/media/book-finder-app.4d271e3e.png";